<script setup lang="ts">
import { computed } from 'vue'
import { useTheme } from '@/composables/useTheme'
import type { BookmarkItem } from '@/types'

const emit = defineEmits<{
  'toggle-sidebar': []
  'toggle-search': []
  'navigate-back': []
}>()

defineProps<{
  breadcrumb: BookmarkItem[]
}>()

const { isDark, themeMode, toggleDark } = useTheme()

// 获取当前域名作为返回首页的链接
const baseUrl = computed(() => {
  return window.location.origin + '/'
})

// 根据主题模式获取图标和提示
const themeIcon = computed(() => {
  if (themeMode.value === 'auto') {
    return isDark.value ? 'fas fa-moon' : 'fas fa-sun'
  }
  return isDark.value ? 'fas fa-sun' : 'fas fa-moon'
})

const themeTooltip = computed(() => {
  if (themeMode.value === 'auto') {
    return isDark.value ? '当前：自动（深色）- 点击切换到浅色' : '当前：自动（浅色）- 点击切换到深色'
  }
  return isDark.value ? '当前：深色 - 点击切换到自动' : '当前：浅色 - 点击切换到自动'
})
</script>

<template>
  <header class="toolbar bg-card shadow-sm border-b border-border">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div class="flex items-center justify-between py-4">
        <div class="flex items-center gap-2">
          <button
            class="btn-icon"
            @click="emit('toggle-sidebar')"
            title="切换侧边栏"
          >
            <i class="fas fa-bars"></i>
          </button>
          <button
            class="btn-icon"
            :class="{ 'opacity-50': breadcrumb.length === 0 }"
            @click="emit('navigate-back')"
            title="返回上级"
          >
            <i class="fas fa-arrow-left"></i>
          </button>
          <a
            class="btn-icon inline-flex items-center justify-center"
            :href="baseUrl"
            title="返回首页"
          >
            <i class="fas fa-home"></i>
          </a>
          <div class="breadcrumb flex items-center text-muted-foreground text-sm ml-4">
            <span
              v-for="(item, index) in breadcrumb"
              :key="item.id"
              class="hover:text-foreground cursor-pointer"
            >
              {{ item.name }}
              <span v-if="index < breadcrumb.length - 1" class="mx-1">/</span>
            </span>
            <span v-if="breadcrumb.length === 0" class="text-foreground font-medium">根目录</span>
          </div>
        </div>

        <div class="flex items-center gap-2">
          <button
            class="btn-icon"
            @click="toggleDark"
            :title="themeTooltip"
          >
            <i :class="themeIcon"></i>
          </button>

          <button
            class="btn-icon"
            @click="emit('toggle-search')"
            title="搜索"
          >
            <i class="fas fa-search"></i>
          </button>
        </div>
      </div>
    </div>
  </header>
</template>
